import { ApiClient } from '../api.client';
import { RetailItemSale } from '../../models/retail-item-sale';

export type RetailSaleEndpoint =
  | 'sale-dockets'
  | 'dockets'
  | 'workshop-jobs'
  | 'booking';

export abstract class RetailItemSaleService {
  protected abstract docketTypePrefix: RetailSaleEndpoint;
  private resourceEndpoint = 'sale-items';

  constructor(protected http: ApiClient) {}

  public getAll() {
    return this.http.get<RetailItemSale[]>(this.resourceEndpoint);
  }

  public getSaleItemsForSellable(sellableId: number) {
    return this.http.get<RetailItemSale[]>(
      `${this.docketTypePrefix}/${sellableId}/${this.resourceEndpoint}`
    );
  }

  public addSaleItem(sellableId: number, saleItem: Partial<any>) {
    return this.http.post<RetailItemSale>(
      `${this.docketTypePrefix}/${sellableId}/${this.resourceEndpoint}`,
      saleItem
    );
  }

  public updateSaleItem(sellableId: number, saleItemId: number, update: any) {
    return this.http.put<RetailItemSale>(
      `${this.docketTypePrefix}/${sellableId}/${this.resourceEndpoint}/${saleItemId}`,
      update
    );
  }

  public quickAdd(
    sellableId: number,
    params: { retail_product_id?: number; barcode?: string; code?: string }
  ) {
    return this.http.post<RetailItemSale>(
      `${this.docketTypePrefix}/${sellableId}/${this.resourceEndpoint}/quick-add`,
      params
    );
  }

  delete(sellableId: number, id: number) {
    return this.http.delete(
      `${this.docketTypePrefix}/${sellableId}/${this.resourceEndpoint}/${id}`
    );
  }
}
